import { defineMessage } from 'services/localization';

export const messages = {
    matchingPolicyViolationNotMatchedToAnyPurchaseOrder: defineMessage(
        'bill_cant_be_approved_s__in_order_to_approve_it'
    ),
    matchingPolicyViolationNotMatchedToAnyPurchaseOrderAndExceedsThreshold: defineMessage(
        'bill_cannot_be_approved__in_order_to_approve_it'
    ),
    insufficientBudgetWithThresholdOrNever: defineMessage('requestname_cant_be_app_ng_the_netgross_setting'),
    insufficientBudgetWithPercentageThreshold: defineMessage('requestname_cant_be_app_nd_the_netgross_setting'),
};
